define('util/cookie',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function get(cname) {
        if (typeof document === "undefined")
            return undefined;
        var match = document.cookie.match(new RegExp(cname + "=([^;]+)"));
        if (match) {
            return match[1];
        }
        else {
            return undefined;
        }
    }
    function set(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        document.cookie = cname + "=" + cvalue + "; path=/; expires=" + d.toUTCString();
    }
    function unset(cname) {
        document.cookie = cname + "=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
    exports.default = { get: get, set: set, unset: unset };
});
//# sourceMappingURL=/assets/javascripts/util/cookie.js.map;
